<template>
    <v-dialog width="1000px" :value="value" @input="toggleModal" persistent scrollable>
        <v-card class="kbLight">
            <v-toolbar class="kbGreen" dark flat>
                <div class="text-h6">{{ $t('general.insertChatInYourWebSite') }}</div>
                <v-spacer></v-spacer>
                <v-btn icon @click="toggleModal(false)">
                    <v-icon>clear</v-icon>
                </v-btn>
            </v-toolbar>
            <v-card-text>
                <v-row>
                    <v-col class="my-4" cols="12" >{{ $t('general.instructionsForInsertingChat') }}</v-col>

                    <pre class="layout v-row" v-highlightjs>
                        <code class="flex xs12 xml">{{script}}</code>

                        <v-btn icon @click="copyScript(script)">
                            <v-icon color="kbGray">file_copy</v-icon>
                        </v-btn>
                    </pre>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red" outlined @click="toggleModal(false)">{{ $t('general.close') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import scriptForms from '@/libs/scriptForms'
import { mapState } from 'vuex'
import notifications from '@/libs/notifications'
export default {
  computed: {
    ...mapState({
      formId: state => state.forms.formId,
      forms: state => state.forms.forms,
      loadingForm: state => state.forms.loadingForm,
      selectedApp: state => state.apps.selectedApp,
      isCloudTask: state => state.auth.isCloudTask
    }),
    div () {
      return scriptForms.getDivKeybeUi()
    },
    script () {
      if (this.isCloudTask) return scriptForms.getScriptChatCloudTask(this.selectedApp.client_key)
      else return scriptForms.getScriptChat(this.selectedApp.client_key)
    },
    scriptElementClickable () {
      return scriptForms.getElementClickable()
    }
  },
  methods: {
    copyScript (text) {
      navigator.clipboard.writeText(text).then(() => {
        notifications.success(this.$t('general.copiedScript'))
      }).catch(() => {
        notifications.error(this.$t('general.errorCopyingScript'))
      })
    },
    toggleModal (value) {
      this.$emit('input', value)
    }
  },
  props: ['value']
}
</script>
